export default __webpack_public_path__ + "8fbb39ac6933b832716ac34cebca3250.svg";